import { ReactElement } from 'react'

import { QuotesList } from '@features/invoices/elements/QuotesList'
import { QuotesTableAccessor } from '@features/invoices/elements/QuotesList/enums/quotesTableAccessor'
import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { getInvoiceDocumentRouteBase } from '@features/invoices/utils/getInvoiceDocumentRouteBase'

import { TableIds } from '../../../../../../../../enums/tableIds'
import { useOrganizationViewUrl } from '../../../../../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../../../../../utils/routing/reactRoute'
import { useContactDetail } from '../../../../contexts/contactDetailContext'

const clientQuotesListColumns: QuotesTableAccessor[] = [
  QuotesTableAccessor.QuoteNumber,
  QuotesTableAccessor.IssueDate,
  QuotesTableAccessor.DueDate,
  QuotesTableAccessor.Description,
  QuotesTableAccessor.NetTotal,
]

const invoiceDocumentRouteBase = getInvoiceDocumentRouteBase(InvoiceDocumentType.Quote)

export const ClientQuotesList = (): ReactElement => {
  const { contact } = useContactDetail()
  const { url: quotesNewUrl } = useOrganizationViewUrl(
    reactRoute.organization.invoices.getNewDocumentRoute(invoiceDocumentRouteBase),
  )

  return (
    <QuotesList
      columns={clientQuotesListColumns}
      contextFilters={{
        customerId: contact.externalId,
      }}
      // A contact with no Zervant externalId cannot own any Zervant quotes, but passing an
      // undefined customerId to useFetchSalesDocuments silently widens to the org-wide list.
      // Disabling the fetch keeps QuotesList mounted so it renders its natural empty state.
      isFetchEnabled={!!contact.externalId}
      newDocumentUrl={`${quotesNewUrl}?contact_id=${contact.id}`}
      persistFiltersInUrl={false}
      showTitle={false}
      tableId={TableIds.ClientQuotesTable}
    />
  )
}
